import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_SITE_CHANGE_ORDERS_REFRESH: createSagaAction('JOB_SITE_CHANGE_ORDERS_REFRESH'),

  JOB_SITE_CHANGE_ORDER_CREATE: createSagaAction('JOB_SITE_CHANGE_ORDER_CREATE'),
  JOB_SITE_CHANGE_ORDER_UPDATE: createSagaAction('JOB_SITE_CHANGE_ORDER_UPDATE'),
  JOB_SITE_CHANGE_ORDER_DELETE: createSagaAction('JOB_SITE_CHANGE_ORDER_DELETE'),

  GET_CHANGE_ORDER_ITEMS: createSagaAction('GET_CHANGE_ORDER_ITEMS'),

  UPLOAD_CHANGE_ORDER_ATTACHMENT: createSagaAction('UPLOAD_CHANGE_ORDER_ATTACHMENT'),
  GET_CHANGE_ORDER_ATTACHMENTS: createSagaAction('GET_CHANGE_ORDER_ATTACHMENTS'),
  UPDATE_CHANGE_ORDER_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_CHANGE_ORDER_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_CHANGE_ORDER_ATTACHMENT: createSagaAction('DELETE_CHANGE_ORDER_ATTACHMENT'),
  FETCH_CHANGE_ORDER_TEMPLATES: createSagaAction('FETCH_CHANGE_ORDER_TEMPLATES')
}

// Action Creators
export const actions = {
  jobSiteChangeOrdersRefresh: ({ jobId, next }) => ({
    type: constants.JOB_SITE_CHANGE_ORDERS_REFRESH.ACTION,
    jobId,
    next
  }),

  createJobSiteChangeOrder: ({
    jobId,
    changeOrderItems,
    estimateId,
    grandTotal,
    description,
    selectedTemplate,
    scopeOfWork,
    schedule,
    payment_schedule
  }) => ({
    type: constants.JOB_SITE_CHANGE_ORDER_CREATE.ACTION,
    jobId,
    changeOrderItems,
    estimateId,
    grandTotal,
    description,
    selectedTemplate,
    scopeOfWork,
    schedule,
    payment_schedule
  }),

  updateJobSiteChangeOrder: ({
    changeOrderId,
    jobId,
    changeOrderItems,
    estimateId,
    grandTotal,
    description,
    number,
    status,
    selectedTemplate,
    scopeOfWork,
    schedule,
    payment_schedule
  }) => ({
    type: constants.JOB_SITE_CHANGE_ORDER_UPDATE.ACTION,
    changeOrderId,
    jobId,
    changeOrderItems,
    estimateId,
    grandTotal,
    description,
    number,
    status,
    selectedTemplate,
    scopeOfWork,
    schedule,
    payment_schedule
  }),

  deleteJobSiteChangeOrder: ({ attachmentId, jobId }) => ({
    type: constants.JOB_SITE_CHANGE_ORDER_DELETE.ACTION,
    jobId,
    attachmentId
  }),

  getChangeOrderItems: estimateId => ({
    type: constants.GET_CHANGE_ORDER_ITEMS.ACTION,
    estimateId
  }),

  // Attachment actions
  uploadAttachmentChangeOrder: ({ formData, changeOrderId }) => ({
    type: constants.UPLOAD_CHANGE_ORDER_ATTACHMENT.ACTION,
    formData,
    changeOrderId
  }),

  getAttachmentsChangeOrder: ({ changeOrderId }) => ({
    type: constants.GET_CHANGE_ORDER_ATTACHMENTS.ACTION,
    changeOrderId
  }),

  updateAttachmentDescriptionChangeOrder: ({
    attachmentId,
    changeOrderId,
    description,
    userId
  }) => ({
    type: constants.UPDATE_CHANGE_ORDER_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    changeOrderId,
    description,
    userId
  }),

  deleteAttachmentChangeOrder: ({ attachmentId, changeOrderId }) => ({
    type: constants.DELETE_CHANGE_ORDER_ATTACHMENT.ACTION,
    attachmentId,
    changeOrderId
  }),

  fetchChangeOrderTemplates: () => ({
    type: constants.FETCH_CHANGE_ORDER_TEMPLATES.ACTION
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_SITE_CHANGE_ORDERS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_SITE_CHANGE_ORDERS_REFRESH.SUCCESS:
      return {
        ...state,
        jobSiteChangeOrders: action.payload
      }
    case constants.JOB_SITE_CHANGE_ORDERS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_SITE_CHANGE_ORDER_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_CHANGE_ORDER_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_CHANGE_ORDER_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.GET_CHANGE_ORDER_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_CHANGE_ORDER_ITEMS.SUCCESS:
      return {
        ...state,
        changeOrderItems: action.payload
      }

    case constants.UPLOAD_CHANGE_ORDER_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_CHANGE_ORDER_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_CHANGE_ORDER_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_CHANGE_ORDER_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobChangeOrderAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_CHANGE_ORDER_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_CHANGE_ORDER_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_CHANGE_ORDER_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }

    case constants.FETCH_CHANGE_ORDER_TEMPLATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.FETCH_CHANGE_ORDER_TEMPLATES.SUCCESS:
      return {
        ...state,
        changeOrderTemplates: action.payload
      }
    case constants.FETCH_CHANGE_ORDER_TEMPLATES.FAILED:
      return {
        error: action.message
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSiteChangeOrderActions.js